import type { Form, FormShare } from "#app/lib/forms";

import { FormAccessDialog } from "./form-access-dialog";

export function FormShareDialog({
  form,
  onOpenChange,
  onChange,
}: {
  form: Form | null;
  onOpenChange: (open: boolean) => void;
  onChange: (formId: string, sharedWith: FormShare[]) => void;
}) {
  return (
    <FormAccessDialog
      description="Sharing form"
      name={form?.name ?? ""}
      onOpenChange={onOpenChange}
      onSharesChange={(shares) => form && onChange(form.formId, shares)}
      open={form != null}
      shares={form?.sharedWith ?? []}
    />
  );
}
